import { tv } from "tailwind-variants";

export const pageLink = tv({
    base: ["tw:block"],

    variants: {
        spread: {
            0: "tw:py-0",
            1: "tw:py-1",
            2: "tw:py-2",
            3: "tw:py-3",
            4: "tw:py-4",
            5: "tw:py-5",
            6: "tw:py-6",
            7: "tw:py-7",
            8: "tw:py-8",
            9: "tw:py-9",
            10: "tw:py-10",
            11: "tw:py-11",
            12: "tw:py-12"
        }
    },
    defaultVariants: {}
});
